module.exports = __webpack_public_path__ + "static/media/trashRedCircled.4cacc531.svg";